import {Injectable} from '@angular/core';
import {Company} from 'classes/company';
import {Observable} from 'rxjs/Observable';
import {TargetGroup} from 'shared/models/target-groups/target-group';
import {Content} from 'shared/models/contents/content';

import {ExportRepository} from '../repositories/export.repository';

@Injectable()
export class ExportService {

  constructor(private exportRepository: ExportRepository) { }

  public getDailyExport(from: string, to: string, filterCompanies: Array<string>, filterTargetGroups: Array<string>): Observable<Blob> {
    return this.exportRepository.getDailyExport(from, to, filterCompanies, filterTargetGroups);
  }

  public getDialogsExport(from: string, to: string, filterCompanies: Array<string>, filterTargetGroups: Array<string>): Observable<Blob> {
    return this.exportRepository.getDialogsExport(from, to, filterCompanies, filterTargetGroups);
  }

  public getQuestionsExport(from: string, to: string, filterCompanies: Array<string>, filterTargetGroups: Array<string>): Observable<Blob> {
    return this.exportRepository.getQuestionsExport(from, to, filterCompanies, filterTargetGroups);
  }

  public getTiplistsExport(from: string, to: string, filterCompanies: Array<string>, filterTargetGroups: Array<string>): Observable<Blob> {
    return this.exportRepository.getTiplistsExport(from, to, filterCompanies, filterTargetGroups);
  }

  public getContentsExport(from: string, to: string, filterCompanies: Array<string>, filterTargetGroups: Array<string>, filterContents: Array<string>): Observable<Blob> {
    return this.exportRepository.getContentsExport(from, to, filterCompanies, filterTargetGroups, filterContents);
  }

  public getEpisodesExport(from: string, to: string, filterCompanies: Array<string>, filterTargetGroups: Array<string>): Observable<Blob> {
    return this.exportRepository.getEpisodesExport(from, to, filterCompanies, filterTargetGroups);
  }

  public getAllCompanies(): Observable<Array<Company>> {
    return this.exportRepository.getAllCompanies();
  }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    return this.exportRepository.getAllTargetGroups();
  }

  public getAllContents(): Observable<Array<Content>> {
    return this.exportRepository.getAllContents();
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/export/services/export.service.ts